import { render, staticRenderFns } from "./Programs_Limited.vue?vue&type=template&id=5a222631&"
import script from "./Programs_Limited.vue?vue&type=script&lang=js&"
export * from "./Programs_Limited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports